<template>
  <Modal v-model="visible" :title="title" width="640" :mask-closable="false" transfer>
    <Form ref="trackForm" :model="form" :rules="rules" :label-width="100" :show-message="false" label-position="right">
      <Form-item label="外教">
        <span>{{ tchText }}</span>
        <span v-if="row && row.country" class="muted">· {{ row.country }}</span>
      </Form-item>
      <Form-item label="入职 / 节点日">
        <span>{{ (row && row.hireDate) || '—' }} / {{ (row && row.reviewDue) || '—' }}</span>
      </Form-item>
      <Form-item label="类型" prop="trackType">
        <Select v-model="form.trackType" transfer style="width: 220px;" placeholder="请选择类型">
          <Option v-for="item in trackTypes" :key="item.code" :value="item.code">{{ item.text }}</Option>
        </Select>
      </Form-item>
      <Form-item label="内容" prop="content">
        <div @paste="handleContentPaste">
          <Input v-model="form.content" type="textarea" :rows="4" :maxlength="2000"
                 placeholder="填写回访/跟踪内容，可粘贴图片作为附件"></Input>
        </div>
      </Form-item>
      <Form-item label="上传附件">
        <el-upload
          class="upload-demo"
          :action="$appConfig.baseUrl + '/upload/fileUpload'"
          :on-change="handleTrackFileChange"
          :on-success="trackFileSuccess"
          :on-progress="handleProgress"
          :headers="headers"
          :before-upload="beforeUploadTrackFile"
          :limit="5"
          multiple
          :file-list="defaultPicsList">
          <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
        </el-upload>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" :loading="saving" @click="submit">保存</Button>
    </div>
  </Modal>
</template>
<script>
import { API_PREFIX, REVIEW_CHANNELS, tchLabel } from '../constants'
const DEFAULT_TRACK_TYPE = 7
export default {
  name: 'ReviewSaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      visible: false,
      saving: false,
      headers: {},
      defaultPicsList: [],
      form: {
        trackType: DEFAULT_TRACK_TYPE,
        content: '',
        picUrl: ''
      },
      rules: {
        trackType: [{ type: 'number', required: true, message: '类型不能为空', trigger: 'change' }],
        content: [{ type: 'string', required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    trackTypes () {
      return (this.$constant && this.$constant.tchTrackRecordType) || []
    },
    tchText () {
      let r = this.row
      if (!r) {
        return '—'
      }
      return tchLabel(r) + '（ID ' + r.tchId + '）'
    },
    title () {
      return '新外教回访 · ' + (tchLabel(this.row) || '')
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.resetForm()
      }
    },
    visible (val) {
      if (val === false) {
        this.$emit('on-close')
      }
    }
  },
  methods: {
    resetForm () {
      this.form = {
        trackType: DEFAULT_TRACK_TYPE,
        content: '',
        picUrl: ''
      }
      this.defaultPicsList = []
      this.$nextTick(() => {
        if (this.$refs.trackForm) {
          this.$refs.trackForm.resetFields()
          this.form.trackType = DEFAULT_TRACK_TYPE
        }
      })
    },
    syncHeaders () {
      this.headers.token = this.$store.get('token')
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account')
        this.headers.password = this.$store.get('password')
      }
    },
    handleTrackFileChange (file, fileList) {
      this.defaultPicsList = fileList
      const names = fileList.filter(f => f.serverName).map(f => f.serverName).join(',')
      this.form.picUrl = names
    },
    trackFileSuccess (res, file, fileList) {
      this.$Message.destroy()
      file.serverName = res && res.data && res.data.name
      const names = fileList.filter(f => f.serverName).map(f => f.serverName).join(',')
      this.form.picUrl = names
      this.defaultPicsList = fileList
    },
    beforeUploadTrackFile (file) {
      const isLt30M = file.size / 1024 / 1024 < 30
      if (!isLt30M) {
        this.$Message.error('文件大小不能超过30MB!')
        return false
      }
      this.syncHeaders()
      this.$Message.loading('服务器正在处理中...', 0)
      return true
    },
    handleProgress (event) {
      if (event && event.percent === 100) {
        event.percent = 99
      }
    },
    handleContentPaste (event) {
      const items = event.clipboardData && event.clipboardData.items
      if (!items) return
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image/') === 0) {
          event.preventDefault()
          const blob = items[i].getAsFile()
          const formData = new FormData()
          formData.append('file', blob, 'paste-' + Date.now() + '.png')
          formData.append('bucket', 'hellokid')
          this.$Message.loading('图片上传中...', 0)
          this.$http.post('/upload/fileUpload', formData, {
            transformRequest: [function (data) { return data }],
            headers: {
              'token': this.$store.get('token'),
              'account': this.$store.get('account') || '',
              'password': this.$store.get('password') || ''
            }
          }).then(res => {
            this.$Message.destroy()
            const data = res.data
            if (data && data.name) {
              const fileInfo = {
                name: data.name,
                url: data.url,
                status: 'success',
                serverName: data.name,
                percentage: 100,
                uid: Date.now()
              }
              this.defaultPicsList = this.defaultPicsList.concat([fileInfo])
              this.form.picUrl = this.defaultPicsList.filter(f => f.serverName).map(f => f.serverName).join(',')
              this.$Message.success('图片上传成功')
            }
          }).catch(() => {
            this.$Message.destroy()
            this.$Message.error('图片上传失败')
          })
          break
        }
      }
    },
    submit () {
      let self = this
      if (!self.row || !self.row.tchId) {
        return
      }
      self.$refs.trackForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('请填写类型和内容')
          return
        }
        let content = (self.form.content || '').trim()
        if (!content) {
          self.$Message.warning('请填写类型和内容')
          return
        }
        self.saving = true
        let trackPayload = {
          tchId: self.row.tchId,
          tchName: tchLabel(self.row),
          trackType: self.form.trackType,
          content: content,
          picUrl: self.form.picUrl || ''
        }
        let note = content.length > 1000 ? content.slice(0, 1000) : content
        let reviewPayload = {
          tchId: self.row.tchId,
          reviewDate: self.$moment().format('YYYY-MM-DD'),
          channel: REVIEW_CHANNELS[0],
          result: 'GOOD',
          note: note,
          nextAction: ''
        }
        self.$http.post('/tchTrack/addTrackRecord', trackPayload).then(function (res) {
          if (!(res && res.data > 0)) {
            self.$Message.error('跟踪记录保存失败')
            return Promise.reject(new Error('track fail'))
          }
          return self.$http.post(API_PREFIX + '/review/save', reviewPayload)
        }).then(function (res) {
          if (res && res.status === 'ok') {
            self.$Message.success('回访已登记')
            self.visible = false
            self.$root.$emit('hr-badges-refresh')
            self.$emit('on-success')
          } else {
            self.$Message.warning('跟踪已写入，回访状态更新失败，请重试或联系管理员')
          }
        }).catch(function () {
          // 错误已由拦截器或上文提示
        }).finally(function () {
          self.saving = false
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.muted {
  margin-left: 6px;
  color: #8B93A7;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ReviewSaveModal.vue?3000dccc